import { v4 as uuidv4 } from 'uuid'

export const carrierLeadTimes = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Carrier Lead Time Code ' + ++index,
  __typename: 'CarrierLeadTime'
}))
